import { useEffect, useState } from "react"

import { SECOND } from "@shared/constants"

import { WOW_MONEY_INTERVAL } from "live/constants"

/**
 * 다음 적립까지 남은 시간(ms)을 1초마다 갱신한다.
 * 주기 시작 시각을 모르면 undefined 를 돌려준다.
 */
const useRemainingTime = (cycleStartedAt?: number) => {
  const [remainingTime, setRemainingTime] = useState<number>()

  useEffect(() => {
    if (!cycleStartedAt) {
      setRemainingTime(undefined)
      return
    }

    const update = () => {
      setRemainingTime(cycleStartedAt + WOW_MONEY_INTERVAL - Date.now())
    }

    update()
    const timer = setInterval(update, SECOND)

    return () => {
      clearInterval(timer)
    }
  }, [cycleStartedAt])

  return remainingTime
}

export default useRemainingTime
